import _ from "lodash";
import Vue from 'vue';


export default {
    SET_MODE(state, data) {
        state.mode = data
    },
    // SET_SELECTED_CATEGORY(state, data) {
    //     state.selectedCategory = data
    // },
    SET_CHANNEL_TIME_FROM(state, data) {
        state.channelTimeFrom = data
    },
    SET_CHANNEL_TIME_TO(state, data) {
        state.channelTimeTo = data
    },
    SET_CUSTOM_CHANNEL_IDS(state, data) {
        state.customChannelIds = data
    },
    SET_LIVE_MODE_START_FROM(state, data) {
        state.liveModeStartFrom = data
    },
    REMOVE_CHANNEL_ID(state, data) {
        state.channelId.filter(n => n !== data);
    },
    SET_VERSION_ID(state, data) {
        state.kind[data.kind].versionId = data.version_id
        state.kind[data.kind].versionName = data.version_name
    },
    SET_CHANNEL_GROUP_FOCUS_POINT_MAP(state, data) {
        state.channelGroupFocusPointMap[data.channelGroup] = data.time
    },
    SET_CHANNEL_DETAIL_DATA(state, data) {
        state.channelDetailDataMap = data;
    },
    PUSH_UNSUBSCRIBE(state, data) {
        state.unsubscribes.push(data);
    },
    UNSUBSCRIBE_FIRE_STORE(state) {
        if (state.unsubscribes.length !== 0) {
            state.unsubscribes.forEach(unsubscribe => {
                unsubscribe();
            });
            state.unsubscribes = [];
        }
    },
    PUSH_UNSUBSCRIBE_FOR_CHART(state, data) {
        state.unsubscribesForChart.push(data);
    },
    UNSUBSCRIBE_FIRE_STORE_FOR_CHART(state) {
        if (state.unsubscribesForChart.length !== 0) {
            state.unsubscribesForChart.forEach(unsubscribe => {
                unsubscribe();
            });
        }
    },
    SET_LATEST_CHANNEL_DATA(state, data) {
        state.latestChannelData = data;
    },
    ADD_ALERT_SUMMARY_LIVE_DATAS(state, data) {
        state.alertSummaryLiveDatas.unshift(data);
    },
    ADD_EVENT_SUMMARY_LIVE_DATAS(state, data) {
        state.eventSummaryLiveDatas.unshift(data);
    },

    SET_CHANNEL_GROUP_CHANNELS(state, data) {
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == data.targetChannelGroup })
        if (index >= 0) {
            state.channelGroupData[index].channels[data.channel.channel_id] = {
                channel_name: data.channel.channel_name,
                value_string_options: data.channel.value_string_options,
                value_number_range: data.channel.value_number_range,
                unit: data.channel.unit,
                kind: data.kind,
            }
        }
    },

    SET_CHANNEL_ORIGINS_MAP(state, data){
        state.channelOriginsMap = data;
    },
    SET_CHANNEL_GROUPS_MAP_BY_ORIGIN(state, data){
        state.channelGroupsMapByOrigin = data;
    },

    SET_REFERENCED_CHANNEL_ID_MAP(state, data){
        state.referencedChannelIdMap = data;
    },
    SET_CHANNEL_MASTER(state, data) {
        state.channelMaster[data.kind] = data.channelMaster
    },
    SET_PREV_FIRESTORE_DOCUMENT(state, data) {
        state.prevFirestoreDocument = data;
    },
    SET_VESSEL_MONITORING_ENGINE_START(state, nowEpochValue) {
        state.vesselMonitoringEngineStart = nowEpochValue;
    },


    SET_SELECTED_CHANNEL_ORIGIN_ID(state, data) {
        state.selectedChannelOriginId = data;
    },

    SET_SELECTED_CHANNEL_GROUP_ID(state, data) {
        Vue.set( state.selectedChannelGroupIdMap, state.selectedChannelOriginId, data );
    },

    SET_ENGINE_INFO(state, data) {
        state.engineInfo = data;
    },
    
    APPEND_VOYAGE_HISTORY_TO_ENGINE_INFO(state, data) {
        state.engineInfo.history = data;
    },

}